import React from 'react';
import {Row} from "react-materialize";
import Client from "./Client";
import Underwriter from "./Underwriter";
import {connect} from "react-redux";
import * as utilsFog from "../../../utils/fog";
import Compta from "./Compta";
import {fetchFogs} from "../../../actions/fog";
//import * as fogActions from "../../../actions/fog";

class CostInvoice extends React.Component {
    constructor(props) {
        super(props);
        this.state = {
            isDirty : false,
            comptaFogs: null,
            comptaFog: null,
            comptaComments: null,
            comptaDispatch: null,
            underwriterSave: null
        };
        this.total = utilsFog.calculateCostInvoices(this.props.fogs.getById(this.props.fog.id).original, this.props.cargoes);
    }

    componentDidMount() {
        if (!this.props.displayAll) {
            this.props.dispatch(fetchFogs(true));
        } else {
            this.props.dispatch(fetchFogs(true, true));
        }
    }

    componentWillReceiveProps(nextProps) {
        this.total = utilsFog.calculateCostInvoices(nextProps.fogs.getById(nextProps.fog.id).original, this.props.cargoes);
    }

    handleChange = () =>{
        let nextState = this.state;
        if(!this.state.isDirty){nextState.isDirty = true;}
        this.setState({...this.state, nextState});
    };

    comptaUpdate = (fogs,fog,comments,dispatch)=>{
        this.setState({
            comptaFogs: fogs,
            comptaFog: fog,
            comptaComments: comments,
            comptaDispatch: dispatch
        });
    };

    comptaSave = (fogs,fog, comments,dispatch) =>{
        let form = Object.assign({}, {...utilsFog.fogToForm(fogs.getById(fog.id).original), comments: comments});

        if (form.overage === undefined || form.overage === null) {
            form.overage = false;
        }
        if (form.brokerageReturn === undefined || form.brokerageReturn === null) {
            form.brokerageReturn = false;
        }

        // Removed dispatch to compile this form with the underwriter one
        //dispatch(fogActions.edit(form, false, this.props.displayAll));
        return form;
    };

    underwriterSave = (result) =>{
        this.setState({underwriterSave:result});
    };

    save = ()=>{
        let form = this.comptaSave(this.state.comptaFogs,this.state.comptaFog,this.state.comptaComments,this.state.comptaDispatch);
        this.state.underwriterSave(form);
        this.setState({isDirty: false});
    };

    render() {
        let formClassName = (this.state.isDirty) ? 'costs-invoices-wrapper dirty':'costs-invoices-wrapper';

        return (
            <div className={formClassName}>
                <Row>
                    <Client {...this.props} total={this.total} />
                </Row>
                <Row>
                    <Underwriter {...this.props} total={this.total} handleChange={this.handleChange} underwriterSave={this.underwriterSave} />
                </Row>
                <Row>
                    <Compta {...this.props} handleChange={this.handleChange} comptaSave={this.comptaSave} comptaUpdate={this.comptaUpdate} />
                </Row>
                <button className="btn btn-primary validate" onClick={this.save} disabled={this.props.loading}>Save</button>
            </div>
        )
    }
}

export default connect((state) => {
    return Object.assign({}, {
        loading: state.fog.loading | state.fog.generating,
        generating: state.fog.generating,
        fogs: state.fog.fogs,
        cargoes: state.cargo.cargoes,

        displayAll: state.connect.displayAll,
    });
})(CostInvoice);


// WEBPACK FOOTER //
// ./src/components/fog/costInvoice/CostInvoice.js